/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListenCount
 */
export interface ListenCount {
    /**
     * 
     * @type {number}
     * @memberof ListenCount
     */
    trackId?: number;
    /**
     * 
     * @type {string}
     * @memberof ListenCount
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof ListenCount
     */
    listens?: number;
}

/**
 * Check if a given object implements the ListenCount interface.
 */
export function instanceOfListenCount(value: object): value is ListenCount {
    let isInstance = true;

    return isInstance;
}

export function ListenCountFromJSON(json: any): ListenCount {
    return ListenCountFromJSONTyped(json, false);
}

export function ListenCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListenCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trackId': !exists(json, 'trackId') ? undefined : json['trackId'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'listens': !exists(json, 'listens') ? undefined : json['listens'],
    };
}

export function ListenCountToJSON(value?: ListenCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trackId': value.trackId,
        'date': value.date,
        'listens': value.listens,
    };
}

